// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Iwxj","input":"styles_input__30hoB"};